import * as React from 'react';
import { Socket, io } from 'socket.io-client';

//@ts-ignore
const config = window.config;
const apiBaseURL = config?.server || 'http://18.217.95.31:8080';
let socketInternal;
let SocketContextInternal;

export const getSocketConnection = (value: any) => {
    if(value) {
        socketInternal = io(apiBaseURL, {
            autoConnect: false,
            reconnection: false,
            query: {
              'userId': value
            }
        });

        SocketContextInternal = React.createContext(socketInternal);
    };
};

export const socket = socketInternal;
export const SocketContext = React.createContext(socketInternal);